import React from "react";
import PropTypes from "prop-types";

import ChargingPinHigh from "./../../../client_customizations/assets/images/icons/High Power Stations.svg";
import ChargingPinPublic from "./../../../client_customizations/assets/images/icons/Public Stations.svg";
import ChargingPinPrivate from "./../../../client_customizations/assets/images/icons/Other Types of Stations.svg";

import "./ChargingStationsMapLegend.scss";
import { FormattedMessage } from "react-intl";

const ChargingStationsMapLegend = ({ chargingStations }) => {
  return (
    <div className="ChargingStationsMapLegend">
      <div className="charger-type">
        <img src={ChargingPinHigh} alt="" />
        <div>
          <b>
            <FormattedMessage
              id="evsnew.highPower.legend"
              defaultMessage="High Power Stations"
              description="High Power Stations"
            />
          </b>
          <p>DC fast chargers</p>
        </div>
      </div>
      <div className="charger-type">
        <img src={ChargingPinPublic} alt="" />
        <div>
          <b>
            <FormattedMessage
              id="evsnew.public.legend"
              defaultMessage="Public Stations"
              description="Public Stations"
            />
          </b>
          <p>Level 2 chargers</p>
        </div>
      </div>
      <div className="charger-type">
        <img src={ChargingPinPrivate} alt="" />
        <div>
          <b>
            <FormattedMessage
              id="evsnew.other.legend"
              defaultMessage="Other Stations"
              description="Other Stations"
            />
          </b>
          <p>Private stations</p>
        </div>
      </div>
    </div>
  );
};

ChargingStationsMapLegend.propTypes = {
  chargingStations: PropTypes.array,
};

ChargingStationsMapLegend.defaultProps = {
  chargingStations: [],
};

export default ChargingStationsMapLegend;
